import { useState, useEffect } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import JourneySection from './components/JourneySection';
import About from './components/About';
import Activities from './components/Activities';
import AtmaNivas from './components/AtmaNivas';
import Gallery from './components/Gallery';
import ArrivalSection from './components/ArrivalSection';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ParticleField from './components/ParticleField';

function App() {
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  const toggleTheme = () => setTheme(t => (t === 'light' ? 'dark' : 'light'));

  return (
    <div className="App">
      <ParticleField count={50} color="#C9902A" />
      <Navbar theme={theme} toggleTheme={toggleTheme} />
      <Hero />
      <JourneySection />
      <About />
      <Activities />
      <AtmaNivas />
      <Gallery />
      <ArrivalSection />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
